var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGcLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "129.94943mm",
    height: "107.50697mm",
    viewBox: "0 0 129.94943 107.50697",
    id: "svg10055",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs10052"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-81.649854,-47.519761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1127-3",
    transform: "translate(10.054606,-8.5909277)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 2.86999
    },
    d: "m 92.957225,99.218593 c 0,0 -0.798543,-28.430851 28.296565,-40.096835 29.09511,-11.665985 49.72971,14.328897 49.72971,14.328897 l -10.23493,7.224657 c 0,0 -14.85962,-18.343087 -35.76204,-9.753285 -20.90242,8.589802 -19.74739,28.778208 -19.74739,28.778208 z",
    id: "path367-5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1071-6",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 3.12987
    },
    d: "m 136.24491,82.842489 a 16.67691,16.67691 0 0 0 -16.67701,16.677018 16.67691,16.67691 0 0 0 16.67701,16.677023 16.67691,16.67691 0 0 0 15.26057,-9.98027 l 14.78204,0.10645 c 0,0 -0.82595,8.43753 -9.87381,16.49667 -9.04786,8.05913 -19.98793,7.46517 -19.98793,7.46517 l -0.36122,12.64316 c 0,0 21.45671,1.11355 34.55758,-17.21859 13.10088,-18.33214 8.18813,-32.872409 8.18813,-32.872409 l -27.23864,0.112137 A 16.67691,16.67691 0 0 0 136.24491,82.842489 Z"
  }), /*#__PURE__*/React.createElement("flowRoot", {
    transform: "matrix(0.24235362,0,0,0.24235362,11.698877,14.3384)",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "53.3333px",
      lineHeight: 1.25,
      fontFamily: "'Eurostile Bold'",
      InkscapeFontSpecification: "'Eurostile Bold, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.09172
    },
    id: "flowRoot4829-1-3-2",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("flowRegion", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "53.3333px",
      fontFamily: "'Eurostile Bold'",
      InkscapeFontSpecification: "'Eurostile Bold, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.19186
    },
    id: "flowRegion4831-0-6-9"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "53.33333588px",
      fontFamily: "'Eurostile Bold'",
      InkscapeFontSpecification: "'Eurostile Bold, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.09172428
    },
    y: 567.93372,
    x: 247.14372,
    height: 66.934761,
    width: 540.62689,
    id: "rect4833-2-7-1"
  })), /*#__PURE__*/React.createElement("flowPara", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      strokeWidth: 1.09172
    },
    id: "flowPara4835-5-5-2"
  }, "TRANSFORMATION")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcLogo);
export default __webpack_public_path__ + "static/media/gcLogo.ce0ff5f43b9b067178729920b0f12141.svg";
export { ForwardRef as ReactComponent };